// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3_7iE","insightsList":"newBusinessInsightsMenu_insightsList__1xcfZ","active":"newBusinessInsightsMenu_active__3GPBS"};